export default __webpack_public_path__ + "static/media/h.f67dfc06.jpg";